import { getParamName } from '../../common';

type SearchParams = Record<string, unknown>;

type TableParams = {
  page?: number;
  pageSize?: number;
  sort?: string;
  search?: string;
};

export const getTableParams = (
  search: SearchParams,
  tableId?: string
): TableParams => {
  return {
    page: search[getParamName('page', tableId)] as number | undefined,
    pageSize: search[getParamName('pageSize', tableId)] as number | undefined,
    sort: search[getParamName('sort', tableId)] as string | undefined,
    search: search[getParamName('search', tableId)] as string | undefined,
  };
};
